<template>
  <div class="vehiculos">
    <select required="required" class="pointer" v-model="vehiculo" :name="id" :id="id">
      <option value="">Seleccione...</option>
      <option :value="item" v-for="item in vehiculos">{{item.observacion}} / {{item.anno}}</option>
    </select>
  </div>
</template>

<script>
  export default {
    props: ["index", "vehiculos", "id"],
    name: "Vehiculo",
    computed: {
      vehiculo: {
        get() {
          return this.$store.state.producto.producto.vehiculosCompatibles[this.index].vehiculo
        },
        set(value) {
          this.$store.commit("producto/SET_KEY_VEHICULO_COMPATIBLE", {key: "vehiculo", index: this.index, data: value})
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .vehiculos {
    select {
      width: 100%;
    }
  }
</style>
